import { ChangeEvent } from 'react';
import Decimal from 'decimal.js';
import { Maths } from 'helpers/maths';

/**
 * Rounds to the 2-decimal precision the input displays (its two blur
 * callbacks — see `FormInputWithPrecisionDisplay`'s own `handleBlur` —
 * are otherwise unrounded), and returns `null` for a blank field instead
 * of `0` so the "$---" empty state stays reachable after a first entry.
 */
export const parseControlledBlurValue = (
  value: number | string
): number | null => {
  if (typeof value === 'string' && value.trim() === '') return null;
  const parsed =
    typeof value === 'number' ? value : Number(value.replaceAll(',', ''));
  return Number.isFinite(parsed)
    ? Maths.parseFloatRound(parsed, 2, Decimal.ROUND_HALF_UP)
    : 0;
};

// `onControlledChange` fires on every keystroke with the raw native event,
// unlike `onControlledBlur` — pull `target.value` through the same parser
// so live and on-blur recalculation agree.
export const parseControlledChangeValue = (
  event: ChangeEvent<HTMLInputElement>
): number | null => parseControlledBlurValue(event.target.value);
